module.exports = __webpack_public_path__ + "img/dd48394ed303c53c115772ce61250026.svg";